import Script from "next/script";
import { useEffect } from "react";

import type { ExternalWidgetTravelotopos as ExternalWidgetTravelotoposType } from "../../types/ExternalWidget";

export type ExternalWidgetTravelotoposContentProps = Pick<ExternalWidgetTravelotoposType, "subdomain">;

const STYLE_ID = "travelotopos-style";

export function ExternalWidgetTravelotoposContent({ subdomain }: ExternalWidgetTravelotoposContentProps) {
    useEffect(() => {
        const linkSrc = subdomain
            ? `https://${subdomain}.travelotopos.com/assets/whiteLabel/travelotoposWhiteLabel.css`
            : null;
        const travelotoposStyleLink = document.getElementById(STYLE_ID);
        if (subdomain && linkSrc && !travelotoposStyleLink) {
            const link = document.createElement("link");
            link.id = STYLE_ID;
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("type", "text/css");
            link.setAttribute("href", linkSrc);
            document.head.appendChild(link);
        }

        return () => {
            document.getElementById(STYLE_ID)?.remove();
        };
    }, [subdomain]);

    const scriptSrc = subdomain
        ? `https://${subdomain}.travelotopos.com/assets/whiteLabel/travelotoposWhiteLabel.js`
        : null;

    return <>{scriptSrc ? <Script src={scriptSrc.toString()} /> : null}</>;
}
